import "./App.css";
//@ts-ignore
import Router from "./Router";
import { init_i18n } from "./hooks/i18n";
import { Toaster } from "react-hot-toast";
init_i18n();
const AppContainer = () => {
  return (
    <>
      <Toaster position="top-right" />
      <Router />
    </>
  );
};

function App() {
  return <AppContainer />;
}

export default App;
